import React from "react";
import ReactMarkdown from "react-markdown";

function AiMessage({ message, threeDots }) {
    return (
        <div className="aiMessageContainer">
            <div className="aiMessageBubble">
                {threeDots ? (
                    <div className="kursvaljaredot-flashing"></div> // Three dots flashing
                ) : (
                    // Så jävla GPT genererat. Men det ser till att länkar öpnar upp i en nytt fönster
                    <ReactMarkdown  components={{
                        a: ({ children, ...props }) => (
                            <a {...props} target="_blank" rel="noopener noreferrer">
                                {children || "Link"} {/* Fallback content to avoid empty links */}
                            </a>
                        ),
                    }}>{message.trim().replace(/\\n/g, "\n")}</ReactMarkdown>
                )}
            </div>
        </div>
    );
}

export default AiMessage;
